import React, { FC } from "react";
import "./title.css";

const Title: FC = () => {
  return (
    <div className="title__container">
      <div className="title__wrapper">
        <img src="/img/widgets/title.png" alt="" />
      </div>
    </div>
  );
};

export default Title;
